module.exports = __webpack_public_path__ + "static/img/show1.dd4a13c2.png";